import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'

export default class extends BaseComponent {

	constructor(props) {
		super(props)
	}

  render() {

    return (
      <header>
        <div className="container">
        	<NavLink to={ this.props.lang === "pl" ? "/" : "/en" }><img className="logo" src="/assets/img/logo.png" alt=""/></NavLink>
        	<div className="switches">
        		{ /* <ul className="lang-switch">
        			<li><a href="/"><img src="/assets/img/pl.png" alt=""/></a></li>
        			<li><a href="/en"><img src="/assets/img/en.png" alt=""/></a></li>
        		</ul>
        		<span className="separator"></span> */ }
        		<ul className="season-switch">
        			<li onClick={ this.props.setSeason.bind(null, "winter") }><img src="/assets/img/winter.png" alt=""/></li>
        			<li onClick={ this.props.setSeason.bind(null, "summer") }><img src="/assets/img/summer.png" alt=""/></li>
        		</ul>
        	</div>
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Header.js